var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147 110.5L162.893 118.755C166.399 120.577 166.507 125.554 163.083 127.525L103.079 162.076C99.9426 163.882 96.0749 163.852 92.9664 161.998L31 125.034L33.3402 126.43",
    stroke: "#59BD39",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3695 81.2618L92.5792 114.086C95.7163 115.886 99.5807 115.851 102.685 113.996L160.635 79.3674C163.924 77.4022 163.871 72.6205 160.54 70.728L102.751 37.8932C99.6057 36.1064 95.741 36.1571 92.6441 38.0258L35.2745 72.644C32.0106 74.6135 32.0629 79.3647 35.3695 81.2618Z",
    stroke: "#1B1B1B",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 89.5L36.3223 96.8601C32.7584 98.6472 32.6172 103.682 36.0753 105.667L92.5792 138.085C95.7163 139.885 99.5807 139.851 102.685 137.996L159.653 103.954C163.145 101.867 162.816 96.7053 159.086 95.079L144 88.5",
    stroke: "#1B1B1B",
    strokeWidth: 4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProject);
export default ForwardRef;